import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - svg
*/
import EditSVG from '../../../assets/images/icons/edit.svg';
import TrashbinSVG from '../../../assets/images/icons/trashbin.svg';
import EmptySVG from '../../../assets/images/icons/empty.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';

/*
    - api
*/
import editBankAccountAPI from '../../../api/edit/BankAccount';
import removeBankAccountAPI from '../../../api/remove/BankAccount';

const List = ({ props, alertProps, reloadFinanceProps }) => {

    /*
       - default data
    */
    const [bankAccount, setbankAccount] = React.useState('loading');
    const [editBankAccountParametrs, setEditBankAccountParameters] = React.useState({
        id: '',
        accountName: {
            value: '',
            color: 'dark'
        },
        cardNumber: {
            value: '',
            color: 'dark'
        },
        bankName: {
            value: '',
            color: 'dark'
        },
        bankAccount: {
            value: '',
            color: 'dark'
        },
        sheba: {
            value: '',
            color: 'dark'
        }
    });
    const [removeBankAccountParameters, setRemoveBankAccountParameters] = React.useState({
        id: '',
        accountName: '',
        bankName: ''
    });
    const bankNameList = [
        '',
        'بانک ملّی ایران',
        'بانک اقتصاد نوین',
        'بانک قرض‌الحسنه مهر ایران',
        'بانک سپه',
        'بانک پارسیان',
        'بانک قرض‌الحسنه رسالت',
        'بانک صنعت و معدن',
        'بانک کارآفرین',
        'بانک کشاورزی',
        'بانک سامان',
        'بانک مسکن',
        'بانک سینا',
        'بانک توسعه صادرات ایران',
        'بانک خاورمیانه',
        'بانک توسعه تعاون',
        'بانک شهر',
        'پست بانک ایران',
        'بانک دی',
        'بانک صادرات',
        'بانک ملت',
        'بانک تجارت',
        'بانک رفاه',
        'بانک حکمت ایرانیان',
        'بانک گردشگری',
        'بانک ایران زمین',
        'بانک قوامین',
        'بانک انصار',
        'بانک سرمایه',
        'بانک پاسارگاد'
    ];

    React.useEffect(() => {
        if (props.bankAccount !== '') {
            if (props.bankAccount.status === 200 && props.bankAccount.data.length > 0) {
                setbankAccount(props.bankAccount.data);
            } else {
                setbankAccount('empty')
            }
        }
    }, [props]);

    /*
        - editBankAccountHandler
    */
    const editBankAccountHandler = (key, value) => {
        if (key === 'accountName' && value !== '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                accountName: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'accountName' && value === '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                accountName: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'cardNumber' && value !== '' && value.length === 16) {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                cardNumber: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'cardNumber' && (value === '' || value.length !== 16)) {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                cardNumber: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'bankName' && value !== '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                bankName: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'bankName' && value === '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                bankName: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'bankAccount' && value !== '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                bankAccount: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'bankAccount' && value === '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                bankAccount: {
                    value: value,
                    color: 'danger'
                }
            });
        }
        if (key === 'sheba' && value !== '' && value.length === 24) {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                sheba: {
                    value: value,
                    color: 'dark'
                }
            });
        } else if (key === 'sheba' && (value === '' || value.length !== 24)) {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                sheba: {
                    value: value,
                    color: 'danger'
                }
            });
        }
    }

    /*
       - editBankAccount
    */
    const editBankAccount = async () => {
        let parameters = {};
        let isValid = 1;
        if (editBankAccountParametrs.accountName.value === '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                accountName: {
                    value: editBankAccountParametrs.accountName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (editBankAccountParametrs.cardNumber.value === '' || editBankAccountParametrs.cardNumber.value.length !== 16) {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                cardNumber: {
                    value: editBankAccountParametrs.cardNumber.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (editBankAccountParametrs.bankName.value === '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                bankName: {
                    value: editBankAccountParametrs.bankName.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (editBankAccountParametrs.bankAccount.value === '') {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                bankAccount: {
                    value: editBankAccountParametrs.bankAccount.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (editBankAccountParametrs.sheba.value === '' || editBankAccountParametrs.sheba.value.length !== 24) {
            setEditBankAccountParameters({
                ...editBankAccountParametrs,
                sheba: {
                    value: editBankAccountParametrs.sheba.value,
                    color: 'danger'
                }
            });
            isValid = 0;
        }
        if (isValid === 1) {
            parameters.Id = editBankAccountParametrs.id;
            parameters.AccountName = editBankAccountParametrs.accountName.value;
            parameters.CardNumber = editBankAccountParametrs.cardNumber.value;
            parameters.BankName = editBankAccountParametrs.bankName.value;
            parameters.bankAccount = editBankAccountParametrs.bankAccount.value;
            parameters.Sheba = editBankAccountParametrs.sheba.value;
            let result = await editBankAccountAPI(parameters);
            if (result === 'success') {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadFinanceProps(Math.floor(Math.random() * 100));
                closeEditBankAccountModal();
            } else {
                alertProps(['danger', 'خطایی رخ داده است']);
            }
            setEditBankAccountParameters({
                accountName: {
                    value: '',
                    color: 'dark'
                },
                cardNumber: {
                    value: '',
                    color: 'dark'
                },
                bankName: {
                    value: '',
                    color: 'dark'
                },
                bankAccount: {
                    value: '',
                    color: 'dark'
                },
                sheba: {
                    value: '',
                    color: 'dark'
                }
            });
        }
    }

    /*
        - removeBankAccount
    */
    const removeBankAccount = async () => {
        let parameters = removeBankAccountParameters.id;
        let result = await removeBankAccountAPI(parameters);
        if (result === 'success') {
            alertProps(['success', 'با موفقیت انجام شد']);
            reloadFinanceProps(Math.floor(Math.random() * 100));
            closeRemoveBankAccountModal();
        } else {
            alertProps(['danger', 'خطایی رخ داده است']);
        }
    }

    /*
        - modal
    */
    const openEditBankAccountModal = (bankAccount) => {
        document.querySelector(`.editBankAccount`).classList.remove('d-none');
        setEditBankAccountParameters({
            id: bankAccount.Id,
            accountName: {
                value: bankAccount.AccountName,
                color: 'dark'
            },
            cardNumber: {
                value: bankAccount.CardNumber,
                color: 'dark'
            },
            bankName: {
                value: bankAccount.BankName,
                color: 'dark'
            },
            bankAccount: {
                value: bankAccount.BankAccount,
                color: 'dark'
            },
            sheba: {
                value: bankAccount.Sheba,
                color: 'dark'
            }
        });
    }

    const closeEditBankAccountModal = () => {
        document.querySelector(`.editBankAccount`).classList.add('d-none');
    }

    const openRemoveBankAccountModal = (bankAccount) => {
        document.querySelector(`.removeBankAccountModal`).classList.remove('d-none');
        setRemoveBankAccountParameters({
            id: bankAccount.Id,
            accountName: bankAccount.AccountName,
            bankName: bankAccount.BankName
        })
    }

    const closeRemoveBankAccountModal = () => {
        document.querySelector(`.removeBankAccountModal`).classList.add('d-none');
    }

    if (bankAccount === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (bankAccount === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block text-center`}
                        component='h2'>
                        لیست حساب‌ های بانکی شما خالی است :(
                    </Typography>
                    <Box
                        className={`my-md`} />
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                        تاکنون هیچ حساب بانکی را ثبت نکرده اید!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (bankAccount !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:992px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '992px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                نام صاحب حساب
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                شماره حساب
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            <Typography>
                                                شماره کارت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '20%'
                                            }}>
                                            شماره شبا
                                        </Box>
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {bankAccount.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            {obj.AccountName}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            {obj.BankAccount}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '20%',
                                                                whiteSpace: 'nowrap'
                                                            }}>
                                                            {obj.CardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '20%',
                                                                whiteSpace:'nowrap'
                                                            }}>
                                                            IR-{obj.Sheba}
                                                        </Box>
                                                        <Box
                                                            className={`d-flex align-item-center justify-content-end`}
                                                            ms={{
                                                                width: '20%'
                                                            }}>
                                                            <Image
                                                                onClick={() => openRemoveBankAccountModal(obj)}
                                                                src={TrashbinSVG}
                                                                alt='remove'
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                            <Box
                                                                className={`mx-sm`} />
                                                            <Image
                                                                onClick={() => openEditBankAccountModal(obj)}
                                                                src={EditSVG}
                                                                alt='edit'
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px'
                                                                }} />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
                <Modal
                    className={`editBankAccount`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: 'calc(100% - 12px) !important'
                            }
                        }}>
                        <Modal.Header
                            className={`border-solid-bottom border-light`}>
                            ویرایش حساب بانکی
                            <Box />
                        </Modal.Header>
                        <Box
                            className={`my-md mt-0`} />
                        <Typography
                            className={`px-lg`}>
                            اطلاعات حساب بانکی خود را ویرایش نمایید.
                        </Typography>
                        <Box
                            className={`p-sm`}
                            component='form'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <TextField
                                            onChange={(event) => editBankAccountHandler('accountName', event)}
                                            color={editBankAccountParametrs.accountName.color}
                                            label='نام صاحب حساب '
                                            icon={EditSVG}
                                            value={editBankAccountParametrs.accountName.value} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            onChange={(event) => editBankAccountHandler('cardNumber', event)}
                                            color={editBankAccountParametrs.cardNumber.color}
                                            label='شماره کارت'
                                            icon={EditSVG}
                                            value={editBankAccountParametrs.cardNumber.value} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12 md-6'>
                                        <Select
                                            onChange={(event) => editBankAccountHandler('bankName', event)}
                                            color={editBankAccountParametrs.bankName.color}
                                            label='نام بانک'
                                            search
                                            init={editBankAccountParametrs.bankName.value}>
                                            {bankNameList.map((obj, index) => {
                                                if (obj !== '') {
                                                    return (
                                                        <Select.Item
                                                            key={index}
                                                            value={obj}>
                                                            {obj}
                                                        </Select.Item>
                                                    )
                                                }
                                                return null;
                                            })}
                                        </Select>
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            onChange={(event) => editBankAccountHandler('bankAccount', event)}
                                            color={editBankAccountParametrs.bankAccount.color}
                                            label='شماره حساب'
                                            icon={EditSVG}
                                            value={editBankAccountParametrs.bankAccount.value} />
                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-6'>
                                        <TextField
                                            onChange={(event) => editBankAccountHandler('sheba', event)}
                                            color={editBankAccountParametrs.sheba.color}
                                            label='شماره شبا'
                                            icon={EditSVG}
                                            value={editBankAccountParametrs.sheba.value} />
                                    </Grid.Item>
                                    <Grid.Item
                                        className={`d-flex`}
                                        size='col-12 md-6'>
                                        <Button
                                            onClick={editBankAccount}
                                            className={`w-25`}
                                            variant='filled'
                                            color='primary'>
                                            تایید
                                        </Button>
                                        <Box
                                            className={`mx-sm`} />
                                        <Button
                                            onClick={closeEditBankAccountModal}
                                            className={`w-25`}
                                            variant='outlined'
                                            color='primary'>
                                            انصراف
                                        </Button>
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Box>
                    </Modal.Wrapper>
                </Modal>
                <Modal
                    className={`removeBankAccountModal`}>
                    <Modal.Wrapper
                        size='xs'
                        ms={{
                            '@media(max-width:576px)': {
                                width: '100% !important'
                            }
                        }}>
                        <Modal.Header
                            className={`border-solid-bottom border-light`}>
                            حذف حساب بانکی
                            <Box />
                        </Modal.Header>
                        <Box
                            className={`my-md mt-0`} />
                        <Typography
                            className={`d-block px-lg`}>
                            آیا حذف حساب انتخاب شده
                            ({removeBankAccountParameters.accountName} - {removeBankAccountParameters.bankName})
                            را تایید می نمایید؟
                        </Typography>
                        <Box
                            className={`p-sm`}
                            component='form'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`d-flex pb-0`}
                                        size='col-6'>
                                        <Button
                                            onClick={removeBankAccount}
                                            className={`mx-lg mr-0`}
                                            variant='filled'
                                            color='danger'>
                                            تایید
                                        </Button>
                                        <Button
                                            onClick={closeRemoveBankAccountModal}
                                            variant='outlined'
                                            color='primary'>
                                            انصراف
                                        </Button>
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Box>
                    </Modal.Wrapper>
                </Modal>
            </React.Fragment>
        );
    }

}

export default List;